<script setup>
import { ref } from "vue";

const copyRef = ref(null);

// remove <!-- ... --> blocks, including newlines
const COMMENT_RE = /<!--[\s\S]*?-->/g;

function formatForEmail() {
  const raw = copyRef.value?.innerHTML ?? "";
  const withoutComments = raw.replace(COMMENT_RE, "");
  return withoutComments;
}

defineExpose({ formatForEmail });
</script>

<template>
  <div ref="copyRef">
    <slot />
  </div>
</template>
